const statusOf = (error: unknown): number | string | undefined =>
  typeof error === 'object' && error !== null && 'status' in error
    ? (error as { status: number | string }).status
    : undefined;

/** The server's answer when this signer is a step behind: someone else set the language, or the text changed. */
export const isConflict = (error: unknown): boolean => statusOf(error) === 409;

/** Unknown, voided or finished contracts all answer the same way so links can't be probed. */
export const isLinkGone = (error: unknown): boolean => {
  const status = statusOf(error);
  return status === 404 || status === 401;
};
